import React, { useState, useEffect } from 'react';
import { getDebugMode, setDebugMode } from '../utils/debug.js';

/**
 * 디버그 모드 토글 컴포넌트
 *
 * 개발자 도구로 콘솔 로그를 켜고 끌 수 있는 플로팅 버튼
 * - localStorage에 DEBUG_MODE 값 저장
 * - Ctrl+Shift+D 단축키 지원
 */
function DebugModeToggle() {
  const [isDebugMode, setIsDebugMode] = useState(getDebugMode());
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Ctrl+Shift+D 단축키로 디버그 모드 토글
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.shiftKey && e.key === 'D') {
        e.preventDefault();
        toggleDebugMode();
      }

      // Ctrl+Shift+L 단축키로 토글 UI 표시/숨김
      if (e.ctrlKey && e.shiftKey && e.key === 'L') {
        e.preventDefault();
        setIsVisible(prev => !prev);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const toggleDebugMode = () => {
    const newMode = !isDebugMode;
    setDebugMode(newMode);
    setIsDebugMode(newMode);

    // 사용자에게 변경 알림 (항상 표시)
    console.log(`%c[Debug Mode] ${newMode ? 'ENABLED ✅' : 'DISABLED ❌'}`,
      `color: ${newMode ? '#10b981' : '#ef4444'}; font-weight: bold; font-size: 14px;`);
  };

  // 개발 환경이 아니면 표시 안 함
  if (!import.meta.env.DEV && !window.location.search.includes('debug')) {
    return null;
  }

  return (
    <>
      {/* 토글 버튼 (우측 하단) */}
      {isVisible && (
        <div style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          zIndex: 9999,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          gap: '8px'
        }}>
          <button
            onClick={toggleDebugMode}
            style={{
              padding: '12px 16px',
              backgroundColor: isDebugMode ? '#10b981' : '#ef4444',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 'bold',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'scale(1)';
            }}
          >
            🐛 Debug: {isDebugMode ? 'ON' : 'OFF'}
          </button>

          <div style={{
            fontSize: '11px',
            color: '#6b7280',
            backgroundColor: 'white',
            padding: '6px 10px',
            borderRadius: '4px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
          }}>
            Ctrl+Shift+D: Toggle Debug
            <br />
            Ctrl+Shift+L: Hide/Show
          </div>
        </div>
      )}

      {/* 작은 인디케이터 (항상 표시) */}
      {!isVisible && (
        <div
          onClick={() => setIsVisible(true)}
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            width: '12px',
            height: '12px',
            borderRadius: '50%',
            backgroundColor: isDebugMode ? '#10b981' : '#9ca3af',
            cursor: 'pointer',
            zIndex: 9999,
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
            transition: 'all 0.2s'
          }}
          title="Click to show debug toggle (Ctrl+Shift+L)"
        />
      )}
    </>
  );
}

export default DebugModeToggle;
